module.exports = __webpack_public_path__ + "img/clos-menu.5fbf3a10.svg";